/**
 * Created by phatbass on 1/1/16.
 */

angular.module('dekky.forms.softdeleteable', [])
	.service('softdeleteable', function () {
		var _progress = false,
			_objects = {},
			_model;

		this.setModel = function (model) {
			_model = model;
		}

		this.check = function (id) {
			if (_objects[id]) {
				return true;
			} else {
				return false;
			}
		}

		this.delete = function (id, callback) {
			if (_progress == false) {
				_progress = true;
				_objects[id] = true;

				_model.delete({id:id}, function() {
					_progress = false;
					if (callback) {
						callback();
					}
				});
			}
		}

		this.restore = function (id) {
			if (_progress == false) {
				_objects[id] = false;

				_model.restore({id:id});
			}
		}
	});